import React, {useEffect, useState} from 'react'
import ModuleNavbar from 'components/Navbars/ModuleNavbar'
import ReactDatetime from "react-datetime";
import moment from "moment"

// reactstrap components
import Select from "react-select";
import {
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Row,
    Col,
    Button, ButtonGroup, Input,
    Nav, NavItem, NavLink, Label, FormGroup
} from "reactstrap";
import {
    MaterialProcedurePricing
} from '../../../components/'
import {
    deleteProcedureMaterial,
    deleteProcedureStaff,
    getOpks,
    getProcedrues,
    getProcedureMaterial,
    getProcedureStaff, editProcedura
} from "../../../actions/ProcedurePricingActions";
import {connect} from "react-redux";
import {
    clearProcedureMaterial,
    clearProcedureStaff,
    editProcedureMaterial,
    getAvailableMaterials,
    getAvailableStaff,
    postProcedureMaterial,
    editProcedureStaff,
    postProcedureStaff,
    getProcedureSummary,
    getStaffArchive,
    getMaterialArchive,
    
} from "../../../actions";
import PersonalProcedurePricing from "../../../components/medicalProceduresComponents/PersonalProcedurePricing";
import ProceduresCostList from "../../../components/medicalProceduresComponents/ProceduresCostList";
import ProceduresList from "../../../components/medicalProceduresComponents/ProceduresList";
import {Form} from "react-bootstrap";
import {getMaterialTypes, getUnitTypes, postMaterialType, postUnitType} from "../../../actions/procedureDefActions";
import procedureDefReducer from "../../../reducers/procedureDefReducer";
import ReportButtons from 'components/common/ReportButtons'
import { set } from 'date-fns';

const MedicalProceduresPricing = (props) => {
    const { 
        procedureDefReducer: {materialTypes, unitTypes}, 
        ProcedurePricingReducer: {
            staff_archive, material_archive, procedure_summary, opk_list, procedures_list, procedure_material, procedure_staff, 
            available_material, available_staff
        }, 
        getStaffArchive, getMaterialArchive, 
        getProcedureSummary, postProcedureStaff, editProcedureStaff, postProcedureMaterial, getAvailableMaterials, 
        getOpks, getAvailableStaff, editProcedureMaterial, clearProcedureStaff, clearProcedureMaterial, deleteProcedureStaff,
        deleteProcedureMaterial, getProcedrues, getProcedureMaterial, getProcedureStaff, getMaterialTypes, getUnitTypes,
        editProcedura
    } = props
    const [activeOpk, setActiveOpk] = useState(null);
    const [activeProcedure, setActiveProcedure] = useState(null);
    const [activeProcedureID, setActiveProcedureID] = useState(null);
    const [displayCostList, setDisplayCostList] = useState(false);
    const [displayProcedureList, setDisplayProcedureList] = useState(false);
    const [func, setFunc] = useState(false);
    const [active, setActive] = React.useState(1)
    const [dateAfter, setDateAfter] = React.useState((new Date()))

    const swapDisplay = (toDisplay) => {
        if (toDisplay === "procedureList") {
            if (displayProcedureList === true) {
                setDisplayProcedureList(false)

            } else {

                setDisplayCostList(false)
                setDisplayProcedureList(true)
            }
        }
        if (toDisplay === "costList") {
            if (displayCostList === true) {
                setDisplayCostList(false)

            } else {

                setDisplayCostList(true)
                setDisplayProcedureList(false)
            }
        }


    }


    const displayFunction = (e) => {
        setFunc(!func);
    }
    useEffect(() => {
        getOpks();
        getAvailableStaff();
        getAvailableMaterials();
        getMaterialTypes();
        getUnitTypes();
    }, []);

    
    useEffect(() => {
        setProceduryFlag(false)
        if (Object.values(opk_list).length > 0 && opk_list) {
            const fieldValue = Object.values(opk_list)[0]
            setActiveOpk({value: fieldValue, label: fieldValue+' '})
            const opk_id = Object.entries(opk_list).filter(key => key[1] === Object.values(opk_list)[0])[0][0];
            if(dateAfter) getProcedrues(opk_id,  moment(dateAfter).format('YYYY-MM-DD'));
            getProcedureSummary(opk_id, true,  moment(dateAfter).format('YYYY-MM-DD'));
        }
        
    }, [opk_list]);


    useEffect(() => {
        setProceduryFlag(false)

        if (Object.keys(procedures_list).length === 0) {
            clearProcedureMaterial();
            clearProcedureStaff();
            setActiveProcedure(null);
        } else {
            const fieldValue = Object.keys(procedures_list)[0]
            const procedure_id = Object.entries(procedures_list).filter(key => key[0] === fieldValue)[0][1];
            setActiveProcedure({value: fieldValue, label: fieldValue+' '});
            getProcedureMaterial(procedure_id);
            setActiveProcedureID(procedure_id);
            getProcedureStaff(procedure_id);
        }


    }, [procedures_list])

    const setOpk = (e) => {
        setActiveOpk(e);
        const fieldValue = e.value
        const opk_id = Object.entries(opk_list).filter(key => key[1] === fieldValue)[0][0];
        getProcedrues(opk_id, moment(dateAfter).format('YYYY-MM-DD'));
        getProcedureSummary(opk_id, true,  moment(dateAfter).format('YYYY-MM-DD'));
        getAvailableStaff(opk_id);

    };
    const changeStatusProcedures=(flag)=>{
        // console.log("funckjja")
        const opk_id = Object.entries(opk_list).filter(key => key[1] === activeOpk.value)[0][0];
        getProcedureSummary(opk_id, flag,  moment(dateAfter).format('YYYY-MM-DD'));

    }
    const setProcedure = (e) => {
        const fieldValue = e.value;
        const procedure_id = Object.entries(procedures_list).filter(key => key[0] === fieldValue)[0][1];
        // getAvailableStaff(procedure_id);

        setActiveProcedure(e);
        setActiveProcedureID(procedure_id)
        getProcedureMaterial(procedure_id);
        getProcedureStaff(procedure_id);

    };
    const [proceduryFlag, setProceduryFlag] =React.useState(false)

    useEffect(() => {
        if(activeOpk){
        const opk_id = Object.entries(opk_list).filter(key => key[1] === activeOpk.value)[0][0];
        if(proceduryFlag) getProcedureSummary(opk_id, "",  moment(dateAfter).format('YYYY-MM-DD'));
        else getProcedureSummary(opk_id, true,  moment(dateAfter).format('YYYY-MM-DD'));}
    },[proceduryFlag])

    const editRow = (flag, id) =>{
        let dict
        dict = {show_procedure: !flag}
        editProcedura(dict, id, proceduryFlag)
      }
      useEffect(() => {
        if(dateAfter === ""){setDateAfter(new Date()) } 
        if (Object.values(opk_list).length > 0 && opk_list && dateAfter !== "" && activeOpk) {
            // const opk_id = Object.entries(opk_list).filter(key => key[1] === Object.values(opk_list)[0])[0][0];
            const opk_id = Object.entries(opk_list).filter(key => key[1] === activeOpk.value)[0][0];

            if(dateAfter) getProcedrues(opk_id,  moment(dateAfter).format('YYYY-MM-DD'));
            getProcedureSummary(opk_id, true,  moment(dateAfter).format('YYYY-MM-DD'));
        }
        
    }, [dateAfter]);
    


    return (
        <div className="content">
            <ModuleNavbar title='Wycena Procedur Medycznych/Usług' icon='nc-icon nc-money-coins'
                          color='#006ba7' func={displayFunction} page={21}/>
            {!func && <Row>
            <Col md="12">
            <Card>
                <CardBody>
                <Row className='text-center'> 
                    <Col md="12" sm="12" className='inline ml-auto mr-auto'>
                    <div className="nav-tabs-navigation"> <div className="nav-tabs-wrapper">
                        <Nav id="tabs" role="tablist" tabs>
                            <NavItem>
                                <NavLink aria-expanded={active === 1} tabIndex={'0'} data-toggle="tab" role="tab" style={{cursor: 'pointer'}}
                                className={active === 1 ? "active wycenaPanel" : ""} onClick={()=>{setActive(1)}}
                                 onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        setActive(1)
                                    }
                                }}>
                                    Wykaz procedur medycznych/usług w&nbsp;OPK
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink aria-expanded={active === 2} tabIndex={'0'} data-toggle="tab" role="tab" style={{cursor: 'pointer'}}
                                className={active === 2 ? "active wycenaPanel" : ""} onClick={()=>{setActive(2)}}
                                 onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        setActive(2)
                                    }
                                }}>
                                    Wycena procedur medycznych/usług
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink aria-expanded={active === 3} tabIndex={'0'} data-toggle="tab" role="tab" style={{cursor: 'pointer', maxWidth:"32vw"}}
                                className={active === 3 ? "active wycenaPanel" : ""} onClick={()=>{setActive(3)}}
                                 onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        setActive(3)
                                    }
                                }}>
                                    Zestawienie jednostkowych kosztów normatywnych procedur/usług
                                </NavLink>
                            </NavItem>
                        </Nav>
                    </div> </div>
                    </Col>
                </Row>
                <Row>
                    <Col  md="12" sm="12" className='ml-auto mr-auto '>
                      <>
                        <label style={{fontSize: "16px"}}>Data obowiązywania procedur</label>
                        <FormGroup>
                            <ReactDatetime
                                inputProps={{
                                    className: "form-control okr",
                                    placeholder: "data początkowa",
                                    'aria-label': "data początkowa",
                                }}
                                dateFormat={"DD-MM-YYYY"}
                                timeFormat={false}
                                locale="pl"
                                onChange={(date) => {
                                    setDateAfter(date)
                                }}
                                value={dateAfter}
                                className='dateSelectWycena'
                            />
                        </FormGroup>
                    <br/></>
                    <label style={{fontSize: "16px"}}>Wybór OPK</label>
                    <span className='nowaOkr'>{Object.values(opk_list).length > 0?
                        <Select
                            className="react-select select-wycena"
                            classNamePrefix="react-select"
                            name="opk"
                            value={activeOpk}
                            onChange={(value) => { setOpk(value) }}
                            options={Object.values(opk_list).map((key, i) => {return {value: key, label: key+' '}})}
                            placeholder="wybierz OPK"
                            aria-label={'wybierz OPK'}
                        />:<i><br/>Brak dostępnych OPK<br/></i>}</span><br/>

                    {active === 1 &&  <><ProceduresList procedures={procedure_summary} opk={activeOpk} editRow={editRow}/>
                    <Row class='text-right'>
                    <Col md='12' >
                        <FormGroup check  className="proceduryCheckBox" style={{textAlign:"right"}}>
                            {/* <label>{`${""}`}</label><br></br> */}
                            <Label check>
                                <Input type="checkbox" onChange={() => setProceduryFlag(!proceduryFlag)}
                                        checked={proceduryFlag}/> <span className="form-check-sign"/>pokaż nieużywane procedury
                            </Label>
                        </FormGroup>
                    </Col>
                    </Row>
                    </>}
                    {active === 2 &&  <>
                        <label style={{fontSize: "16px"}}>{`Wybór procedury medycznej/usługi`}</label>
                        {Object.keys(procedures_list).length > 0?
                            <span className='nowaOkr'> <Select
                                className="react-select select-wycena"
                                classNamePrefix="react-select"
                                name="procedureSelect"
                                value={activeProcedure}
                                onChange={(value) => { setProcedure(value) }}
                                options={Object.keys(procedures_list).map((key, i) => {return {value: key, label: key+' '}})}
                                placeholder="wybierz procedurę"
                            /> </span>:<i><br/>Brak dostępnych procedur<br/></i>}<br/>
                           
                        {Object.keys(procedures_list).length !== 0 && <MaterialProcedurePricing materials={procedure_material}
                            editProcedureMaterial={editProcedureMaterial}
                            available_material={available_material}
                            postProcedureMaterial={postProcedureMaterial}
                            activeProcedureID={activeProcedureID}
                            getMaterialArchive={getMaterialArchive}
                            material_archive={material_archive}
                            unitTypes={unitTypes}
                            materialTypes={materialTypes}
                            deleteProcedureMaterial={deleteProcedureMaterial}
                        />}
                        {Object.keys(procedures_list).length !== 0 && <PersonalProcedurePricing postProcedureStaff={postProcedureStaff}
                            editProcedureStaff={editProcedureStaff}
                            procedure_staff={procedure_staff}
                            available_staff={available_staff}
                            activeProcedureID={activeProcedureID}
                            getStaffArchive={getStaffArchive}
                            staff_archive={staff_archive}
                            deleteProcedureStaff={deleteProcedureStaff}/>}
                    </>}
                    {active === 3 &&  <><ProceduresCostList procedures={procedure_summary} opk={activeOpk} editRow={editRow} />
                    <Row class='text-right'>
                    <Col md='12'>
                        <FormGroup check  className="proceduryCheckBox" style={{textAlign:"right"}}>
                            {/* <label>{`${""}`}</label><br></br> */}
                            <Label check>
                                <Input type="checkbox" onChange={() => setProceduryFlag(!proceduryFlag)}
                                        checked={proceduryFlag}/> <span className="form-check-sign"/>pokaż nieużywane procedury
                            </Label>
                        </FormGroup>
                    </Col>
                    </Row>
                    </>}

                    </Col>
                </Row>
                </CardBody>
                </Card>
            </Col>
        </Row>}
            {func && <>
                <Card>
                    <CardHeader>
                        <CardTitle tag="h5">
                            Drogi Użytkowniku,
                        </CardTitle>
                    </CardHeader>
                    <CardBody style={{textAlign: 'justify', lineHeight: '2', fontSize: '14px'}}>
                    w&nbsp;panelu <span className='text-wycena'>„Wycena procedur medycznych/usług”</span> masz możliwość wyceny procedur medycznych i&nbsp;usług 
                    wykonywanych w&nbsp;poszczególnych OPK, według metody opartej o&nbsp;koszty typowo zużywanych zasobów.
                    <br/>
                    Aby wygenerować wykaz procedur medycznych/usług:
                    <ul>
                        <li>wybierz zakładkę „Wykaz procedur medycznych/usług w&nbsp;OPK”,</li>
                        <li>wybierz dany OPK z&nbsp;listy,</li>
                        <li>kliknij w&nbsp;przycisk 
                            <ButtonGroup className='my-0 mx-2'>
                                <Button className="btn-round m-0" color='wycena' outline type="button" size="sm">
                                .doc
                                </Button>
                                <Button className="btn-round m-0" color='wycena' outline type="button" size="sm">
                                .csv
                                </Button>
                                <Button className="btn-round m-0" color='wycena' outline type="button" size="sm">
                                .xlsx
                                </Button>
                            </ButtonGroup>, 
                            w&nbsp;celu pobrania do&nbsp;wydruku.</li>
                    </ul>
                    <strong> Uwaga! </strong>Pobrane tabele w postaci .xlsx domyślnie zawierają dane w formacie tekstowym. Aby zmienić na format liczbowy należy zaznaczyć dane z kolumny, następnie wybrać
                        zakładkę <i>Dane-{">"}Tekst jako kolumny-{">"}Zakończ</i> lub jeśli bo zaznaczeniu danych pojawia się ikona błędu z wykrzyknikiem należy kliknąć na ikonę i wybrać konwersję do liczb.
                        Pobranie tabeli w postaci CSV zapewnia poprawny format danych.<br/><br/>
                    Aby dokonać wyceny procedur medycznych/usług w&nbsp;systemie:
                    <ol>
                        <li>wybierz dany OPK z&nbsp;listy,</li>
                        <li>
                            wybierz z&nbsp;listy procedurę/usługę, którą chcesz wycenić,
                            <ul>
                                <li>
                                    zdefiniuj zasoby materiałowe - uzupełnij kolejno pola definiując je&nbsp;ręcznie lub wybierając z&nbsp;listy zaimportowanych zasobów:<br/>
                                    - indeks materiału,<br/>
                                    - materiał/lek/środek spożywczy specjalnego przeznaczenia żywieniowego/wyrób medyczny,<br/>
                                    - typ,<br/>
                                    - liczba procedur/usług,<br/>
                                    - jednostka miary,<br/>
                                    - ilość jednostek miary zużyta na&nbsp;realizację procedury/usługi,<br/>
                                    - cena jednostki miary w&nbsp;zł,<br/>
                                    - i&nbsp;kliknij w przycisk <Button className="btn btn-round my-0 mx-2" outline size='sm' color="wycena" type="button" >
                                        <i className='nc-icon nc-simple-add'></i>
                                    </Button> dodaj.
                                </li>
                                Dodany zasób wraz z&nbsp;wyliczonym wkładem do&nbsp;kosztu jednostkowego pokaże się na&nbsp;liście.<br/>
                                Poprzez opcje masz możliwość usunięcia procedury/usługi z&nbsp;listy lub edytowania poszczególnych składników wyceny.
                                <li>
                                    zdefiniuj zasoby osobowe - uzupełnij kolejno pola definiując je&nbsp;ręcznie lub wybierając z&nbsp;listy zaimportowanych zasobów:<br/>
                                    - grupa personelu,<br/>
                                    - liczba procedur/usług,<br/>
                                    - jednostka czasu,<br/>
                                    - ilość jednostek czasu zużyta na&nbsp;realizację procedury/usługi,<br/>
                                    - koszt jednostki czasu w&nbsp;zł,<br/>
                                    - i&nbsp;kliknij w&nbsp;przycisk <Button className="btn btn-round my-0 mx-2" outline size='sm' color="wycena" type="button" >
                                        <i className='nc-icon nc-simple-add'></i>
                                    </Button> dodaj.<br/>
                                </li>
                                Dodany zasób wraz z&nbsp;wyliczonym wkładem do&nbsp;kosztu jednostkowego pokaże się na&nbsp;liście.<br/>
                                Poprzez opcje masz możliwość usunięcia procedury/usługi z&nbsp;listy lub edytowania poszczególnych składników wyceny.
                            </ul>
                        </li>
                    </ol>
                    Aby wygenerować zestawienie jednostkowych kosztów normatywnych procedur/usług:
                    <ul>
                        <li>wybierz zakładkę „Zestawienie jednostkowych kosztów normatywnych procedur/usług”,</li>
                        <li>wybierz dany OPK z&nbsp;listy,</li>
                        <li>kliknij w&nbsp;przycisk 
                            <ButtonGroup className='my-0 mx-2'>
                                <Button className="btn-round m-0" color='wycena' outline type="button" size="sm">
                                .doc
                                </Button>
                                <Button className="btn-round m-0" color='wycena' outline type="button" size="sm">
                                .csv
                                </Button>
                                <Button className="btn-round m-0" color='wycena' outline type="button" size="sm">
                                .xlsx
                                </Button>
                            </ButtonGroup>, w&nbsp;celu pobrania do&nbsp;wydruku.</li>
                    </ul>
                        <Button className="btn-round" outline color="wycena" onClick={() => {
                            window.focus();
                            window.scrollTo(0, 0);
                            displayFunction('main');
                        }} style={btnNewStyle}> Powrót </Button>
                    </CardBody>
                </Card>
            </>}
        </div>
    )
}
const mapStateToProps = state => ({
    ProcedurePricingReducer: state.ProcedurePricingReducer,
    procedureDefReducer: state.procedureDefReducer
});
const btnNewStyle = {
    float: 'right',
    margin: '0px !important'
}
export default connect(mapStateToProps, {
    getMaterialArchive,
    getStaffArchive,
    getProcedureSummary,
    postProcedureStaff,
    editProcedureStaff,
    getAvailableMaterials,
    getAvailableStaff,
    editProcedureMaterial,
    getOpks,
    getProcedrues,
    clearProcedureStaff,
    clearProcedureMaterial,
    getProcedureMaterial,
    getProcedureStaff,
    postProcedureMaterial,
    postMaterialType,
    getMaterialTypes,
    getUnitTypes,
    deleteProcedureStaff,
    deleteProcedureMaterial,
    editProcedura
})(MedicalProceduresPricing)